export default "__VITE_ASSET__Bj68NJYp__"